<template>
    <div  class="comm-settings-top-nav" style="padding:0px !important;">
        <div class="justify-content-start" v-if="componentname == 'show-user' || componentname == 'show-user-groups'">
            <nav class="navbar navbar-expand-lg p-0">
                <div class="collapse navbar-collapse">
                    <div class="navbar-nav w-100 top-nav-bar">
                        <a class="nav-item nav-link" style="width:15%" v-on:click="tableType = 'show-user';changeComponent('show-user')" :class='(tableType === "show-user")?"active":"inactive"'>{{$t('Users')}}<span class="sr-only">(current)</span></a>
                        <a class="nav-item nav-link" style="width:15%"
                         v-show="isComponentEnabled('user-groups','settings-user')"
                         v-on:click="tableType = 'show-user-groups';changeComponent('show-user-groups');showAddUserGroupButton = true"
                          :class='(tableType === "show-user-groups")?"active":"inactive"'>{{$t('Groups')}}</a>
                    </div>
                </div>
            </nav>
        </div>
        <!-- <div class="d-inline-flex w-100" style="height:42px;">
        <div class="justify-content-start"  style="padding:0px !important;width:90%;position:relative">
            <back-button v-if="componentname != 'show-user' || componentname != 'show-user-groups'" v-on:click.native="clickToChangeComponent()" style="position: absolute;bottom: 7px;inset-inline-start:5px;"></back-button>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb comm-settings-top-nav m-0" v-show="tableType == 'show-user'" style="padding-inline-start:4%">
                    <li class="breadcrumb-item"><a v-on:click="changeComponent('show-user')" :class='{active: tableType === "show-user"}'>Users</a></li>
                    <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{seletedUserName}}</li>
                </ol>
                <ol class="breadcrumb comm-settings-top-nav m-0" v-show="tableType == 'show-user-groups'" style="padding-inline-start:4%">
                    <li class="breadcrumb-item"><a v-on:click="changeComponent('show-user-groups');" :class='{active: tableType === "show-user-groups"}'>Groups</a></li>
                    <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{seletedUserGroupName}}</li>
                </ol>
            </nav>
        </div>
        <div class="p-0 primary-btn-style justify-content-end" style="width:10%">
            <button type="button" class="btn btn-outline-primary" v-show="showAddButton && tableType == 'show-user'" v-on:click="changeComponent('add-user')">Add</button>
            <button type="button" class="btn btn-outline-primary" v-show="showUserGroupAddButton" v-on:click="changeComponent('add-user-group')">Add</button>
        </div>
        </div> -->
        <div style="width:100%;height:100%">
            <user-comp v-show="tableType == 'show-user'"></user-comp>
            <user-groups-comp ref="userGroupRef" v-if="tableType == 'show-user-groups'" @updateGroupNavBarComponent="updateNavBarComponent" ></user-groups-comp>
        </div>
    </div>
</template>

<script>
import Utils from"../../../src/components.utils.js"
import userGroupsComp from "../userGroups/UserGroups.vue"
import usersTable from "./Users.vue"
export default {
    props : ["seletedUserName", "showAddButton", "seletedUserGroupName","componentname","showTopNav"],
    emits:["changeSelectedComponent"],
    components:{
        "user-groups-comp":userGroupsComp,
        "user-comp":usersTable
    },
    data(){
        return{
            tableType:'show-user',
            showUserGroupAddButton:false
        };
    },
    methods:{
        isComponentEnabled(comp, dependedComp){
            return (Utils.isComponentEnabled(comp) && Utils.isComponentEnabled(dependedComp))
      },
      clickToChangeComponent(){
          if(this.tableType == 'show-user'){
            this.changeComponent('show-user');
          }else{
            this.changeComponent('show-user-groups');
          }
      },
      updateNavBarComponent(showGroupAddButton, groupName, comp){
          this.showUserGroupAddButton = showGroupAddButton
          this.seletedUserGroupName = groupName
          this.componentname = comp;
      },
      changeComponent(comp){
            this.$emit("changeSelectedComponent", comp);
            let enableAddGroupButton = false
            if(this.tableType == 'show-user-groups'){
                    this.$emit("changeSelectedComponent",comp)
                    this.$refs.userGroupRef.changeSelectedComponent(comp)
                if(comp == "show-user-groups"){
                    enableAddGroupButton = true
                }else if(comp == "user-group-info"){
                    enableAddGroupButton = true
                }
            }
            this.showUserGroupAddButton = enableAddGroupButton
      },
    },
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

.activeclass {
  color: $active-blue;
}
.comm-settings-top-nav{
    background: $primary-background !important;
}

.btn{
    height:100%;
}

.breadcrumb{
  padding: .75rem 1rem !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.search-bar-comm-style {
  height: 30px;
  position: relative;
  input {
    border: $border-color;
    position: absolute;
    top: 29%;
    inset-inline-start:2%;
    height: 25px;
    padding-inline-start: 9%;
  }
  svg {
    position: absolute;
    inset-inline-start:10px;
    top: 48%;
  }
}

.primary-btn-style{
    button{
        height: 35px;
        width: 70px;
        font-size:14px;
    }
}
.nav-item{
    color: $dull-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid #077bff ;
    font-weight:500;
    font-size:15px;
}

.top-nav-bar{
    background:$primary-background;
}
</style>